import api from 'Application/api/api';

const getEmployeeExaminersByMeasure = (measure, cancelToken = null) =>
    api.get(`/users/employee-examiners/by-measure/${measure}`, {
        cancelToken,
    });

export default getEmployeeExaminersByMeasure;
